import axios from 'axios';
// import { Notification } from 'element-ui';
import { GetAuthToken } from 'rj-server-auth-token';
// import { jumpShutDownPage } from '@/libs/util';
import { getSign } from './requestEncryption';
import Cookies from 'js-cookies';
import { addCheckParams } from '../libs/requestParamUtil';

// let querystring = require('querystring');
// 允许跨域请求发送cookie
let CreditAxios = axios.create();

CreditAxios.defaults.withCredentials = true;
CreditAxios.defaults.baseURL = `${window._env_.VUE_APP_REQUEST_ADDRESS}/`;
// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/order-lifecycle-uat02' : '/order-lifecycle-uat02';
CreditAxios.defaults.headers.post['Content-Type'] = 'application/json'; // application/x-www-form-urlencoded , multipart/form-data
// http请求拦截
CreditAxios.interceptors.request.use(
  config => {
    // if (config.headers.common.Accept.indexOf('application/json') >= 0) {
    //   // config.data = querystring.stringify(config.data);
    //   console.log(config);
    //
    // }
    config.headers['web-sign-server-auth'] = GetAuthToken({
      sysId: '13a22efb2f7343b78630dd5741c63561',
      accessKeySecret: '31EE9BF5F4B04F5EB91C86866AD24DD4'
    });
    config.headers.token = localStorage.getItem('autoToken') || '';
    config.headers['sysId'] = '13a22efb2f7343b78630dd5741c63561';
    config.headers['timeOut'] = new Date().getTime();
    config.headers['sid_login'] = localStorage.getItem('sidLogin') && JSON.parse(localStorage.getItem('sidLogin') || '');
    config.headers['union_session_ticket'] = localStorage.getItem('union_session_ticket');

    let timestamp = localStorage.getItem('timestamp');
    if (timestamp && timestamp + 600000 > new Date().getTime()) {
      timestamp = new Date().getTime();
      localStorage.setItem('timestamp', timestamp);
    } else {
      timestamp = new Date().getTime();
    }
    const sign = getSign(config, axios, timestamp);
    config.headers['sign'] = sign;
    config.headers['timestamp'] = timestamp;

    config = addCheckParams(config);

    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

// http响应拦截器
CreditAxios.interceptors.response.use(
  res => {
    console.log(res);
    // // 停机维护
    // if (res.data.status === '503') {
    //   jumpShutDownPage(res.data.data);
    // }

    // if (res.headers['content-type'].indexOf('application/octet-stream') >= 0) {
    //   return res;
    // }
    // let json = res.data;
    // if (json && json.status !== '200' && json && json.status !== '302') {
    //   Notification.error({
    //     message: json.error || json.err
    //   });
    // } else if (json && json.status === '302') {

    // }
    return res;
  },
  error => {
    if (error.message.includes('428')) {
      Cookies.removeItem('ruijieportal', '/', '.ruijie.com.cn');
      Cookies.removeItem('PartnerUser', '/', '.ruijie.com.cn');
      Cookies.removeItem('phplogin', '/', '.ruijie.com.cn');
      Cookies.removeItem('thh_auth', '/', '.ruijie.com.cn');
      Cookies.removeItem('sid_login', '/', '.ruijie.com.cn');
      // 干掉切换的渠道
      Cookies.removeItem('xsyx_chang_user', '/', '.ruijie.com.cn');
      window.localStorage.removeItem('union_session_ticket');
      if (window._env_.NODE_ENV !== 'pro') {
        window.location.href = `${window.location.origin}/toLoginPage`;
      } else {
        window.location.href = `https://ces.ruijie.com.cn/toLoginPage`;
      }
      // return Notification.warning({
      //   message: '登录验证失败或登录已失效，请重新登录'
      // });
    }
    // Notification.error({
    //   message: error.response.err || '请求服务器失败'
    // });
    return Promise.reject(error);
  }
);
// axios 具体使用 请参考 https://github.com/axios/axios
export default axios;

export const tickToGetToken = (data) => CreditAxios.post(`/auto-rebate-platform/sys/ssoLogin`, data);

export const getAutoMenus = () => CreditAxios.get(`/auto-rebate-platform/sys/user/getMenus`);
